<div
  class="invoices background-white scrollable-container table-container"
  #scrollableContainer
  (scroll)="onScroll($event)"
>
  <div class="filter-and-add" *ngIf="selectedInvoicesNum === 0">
    <div class="invoice-filter">
      <mat-form-field
        [hideRequiredMarker]="true"
        style="height: 48px; width: 230px"
        appearance="outline"
      >
        <mat-label>Search by konto or name</mat-label>
        <input
          matInput
          #input
          [(ngModel)]="searchInput"
        />
        <mat-icon matSuffix *ngIf="!searchInput">search</mat-icon>
      </mat-form-field>
    </div>
    <div class="add-invoice">
      <button class="add-new-button pointer bulk-action" (click)="openBulkImport()">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11 12H13V9H16V7H13V4H11V7H8V9H11V12ZM6 16C5.45 16 4.97933 15.8043 4.588 15.413C4.196 15.021 4 14.55 4 14V2C4 1.45 4.196 0.979 4.588 0.587C4.97933 0.195667 5.45 0 6 0H18C18.55 0 19.021 0.195667 19.413 0.587C19.8043 0.979 20 1.45 20 2V14C20 14.55 19.8043 15.021 19.413 15.413C19.021 15.8043 18.55 16 18 16H6ZM6 14H18V2H6V14ZM2 20C1.45 20 0.979333 19.8043 0.588 19.413C0.196 19.021 0 18.55 0 18V4H2V18H16V20H2Z" fill="#5E5E70"/>
        </svg>
        &nbsp;Bulk import
      </button>
      <button style="width: 202px" class="primary-button" (click)="addNewAccount()">
        <img src="assets/icons/add.svg" alt="Add Icon">
        &nbsp;<span>Add account</span>
      </button>
    </div>
  </div>

  <div class="action-bar" *ngIf="selectedInvoicesNum > 0">
    <div style="display: flex; align-items: center; margin-left: 16px">
      <mat-icon
        style="margin-right: 8px; cursor: pointer; font-size: 26px"
        (click)="toggleAllSelection(false)"
        >close</mat-icon>
      <span class="custom-button-selected">
        {{ selectedInvoicesNum }}
        {{ selectedInvoicesNum == 1 ? 'item' : 'items' }} selected
      </span>
    </div>
    <div style="display: flex; align-items: center">
      <button class="custom-button" mat-button (click)="toggleAllSelection(true)">
        Select all
      </button>
      <button class="custom-button" *ngIf="selectedInvoicesNum >= 2" mat-button (click)="toggleAllSelection(false)">
        Unselect all
      </button>
      <button class="custom-button" *ngIf="selectedInvoicesNum === 1" mat-button (click)="toggleAllSelection(false)">
        Unselect
      </button>
      <div
        class="icon-wrapper"
        (click)="$event.stopPropagation(); bulkDeleteAccounts()"
        (mouseover)="isHovered = true"
        (mouseleave)="isHovered = false"
      >
        <svg
          width="24" height="18" viewBox="0 0 16 18" fill="none"
          xmlns="http://www.w3.org/2000/svg"
          [style.fill]="isHovered ? '#1E31CF' : '#27272C'"
        >
          <path d="M3 18C2.45 18 1.97933 17.8043 1.588 17.413C1.196 17.021 1 16.55 1 16V3H0V1H5V0H11V1H16V3H15V16C15 16.55 14.8043 17.021 14.413 17.413C14.021 17.8043 13.55 18 13 18H3ZM13 3H3V16H13V3ZM5 14H7V5H5V14ZM9 14H11V5H9V14Z"/>
        </svg>
      </div>
    </div>
  </div>

  <table
    *ngIf="dataSource?.filteredData?.length && !isLoading"
    mat-table
    [dataSource]="dataSource"
    matSort
    class="mt-20 si-table"
  >
    <ng-container matColumnDef="checkbox">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <mat-checkbox
          class="custom-checkbox"
          [(ngModel)]="element.selected"
          [checked]="element.selected"
          (change)="toggleCheckbox(element)"
        ></mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="konto">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="konto">
        <span class="roboto">Konto</span>
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.konto | slice:0:20 }}<span *ngIf="element.konto?.length > 20">...</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="nazivKonta">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="nazivKonta">
        <span class="roboto">Naziv konta</span>
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.nazivKonta | slice:0:40 }}<span *ngIf="element.nazivKonta?.length > 40">...</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <div class="operations triggered" style="display: flex; align-items: center">
          <div
            class="icon-wrapper2"
            (click)="$event.stopPropagation(); editAccount(element)"
            [style.visibility]="selectedInvoicesNum > 0 ? 'hidden' : 'visible'"
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
              (mouseover)="isHovered = true" (mouseleave)="isHovered = false">
              <path
                d="M2.86206 17.125H4.26206L12.8871 8.5L11.4871 7.1L2.86206 15.725V17.125ZM17.1621 7.05L12.9121 2.85L14.3121 1.45C14.6954 1.06667 15.1664 0.875 15.7251 0.875C16.2831 0.875 16.7537 1.06667 17.1371 1.45L18.5371 2.85C18.9204 3.23333 19.1204 3.696 19.1371 4.238C19.1537 4.77933 18.9704 5.24167 18.5871 5.625L17.1621 7.05ZM15.7121 8.525L5.11206 19.125H0.862061V14.875L11.4621 4.275L15.7121 8.525Z"
                [style.fill]="isHovered ? '#1E31CF' : '#27272C'"
              />
            </svg>
          </div>
          <div
            class="icon-wrapper"
            (click)="$event.stopPropagation(); deleteAccount(element)"
            (mouseover)="isHovered1 = true"
            (mouseleave)="isHovered1 = false"
            [style.visibility]="selectedInvoicesNum > 0 ? 'hidden' : 'visible'"
          >
            <svg width="24" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg"
              [style.fill]="isHovered1 ? '#1E31CF' : '#27272C'">
              <path d="M3 18C2.45 18 1.97933 17.8043 1.588 17.413C1.196 17.021 1 16.55 1 16V3H0V1H5V0H11V1H16V3H15V16C15 16.55 14.8043 17.021 14.413 17.413C14.021 17.8043 13.55 18 13 18H3ZM13 3H3V16H13V3ZM5 14H7V5H5V14ZM9 14H11V5H9V14Z"/>
            </svg>
          </div>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr class="show-on-hover" mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <ng-container *ngIf="!isLoading && !dataSource?.filteredData?.length">
    <div class="no-data-wrapper">
      <img
        [style.width]="!dataSource?.filteredData?.length && !isSearchFilterOn ? '139px' : '200px'"
        height="225px"
        [src]="!dataSource?.filteredData?.length && !isSearchFilterOn ? '/assets/icons/printer.svg' : '/assets/icons/empty-search.svg'"
      />
      <p class="no-data-title">No accounts</p>
      <p *ngIf="!dataSource?.filteredData?.length && !isSearchFilterOn">
        Press the button at the top right corner <br /> to create your first account.
      </p>
      <p *ngIf="!dataSource?.filteredData?.length && isSearchFilterOn">
        We are sorry, we couldn't find any matching <br /> results. Please try different search.
      </p>
    </div>
  </ng-container>

  <ng-container *ngIf="isLoading">
    <table class="si-table">
      <tbody>
        <tr *ngFor="let number of [1, 2, 3, 4, 5]">
          <td>
            <ngx-skeleton-loader count="1" appearance="line"
              [theme]="{ height: '15px', width: '100px', 'border-radius': '3px' }">
            </ngx-skeleton-loader>
          </td>
          <td>
            <ngx-skeleton-loader count="1" appearance="line"
              [theme]="{ height: '15px', width: '300px', 'border-radius': '3px' }">
            </ngx-skeleton-loader>
          </td>
          <td>
            <ngx-skeleton-loader count="1" appearance="circle"></ngx-skeleton-loader>
            <ngx-skeleton-loader count="1" appearance="circle"></ngx-skeleton-loader>
          </td>
        </tr>
      </tbody>
    </table>
  </ng-container>
</div>
